<template>
  <div>
    <div class="document-container" ref="document-content">
      <div class="document" v-if="$route.params.title">
        <templace v-bind:is="document" />
        <a
          :href="`https://gitlab.com/-/ide/project/kirafan/calculator/edit/master/-/src/docs/${uri}`"
          target="_blank"
        >
          <md-content class="md-primary document-edit">Edit this document ></md-content>
        </a>
      </div>
      <md-card class="card document" v-else>
        <md-card-header>
          <div class="md-title">{{$t("Documents")}}</div>
        </md-card-header>
        <WIP />
        <md-list>
          <md-list-item
            v-for="item in menu"
            :key="item.name"
            :to="'/document' + item.to"
          >{{item.name}} {{$t(item.name)}}</md-list-item>
        </md-list>
      </md-card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import WIP from "@/components/WIP.vue";
import menu from "@/menu.js";

export default {
  name: "Document",
  components: { WIP },
  data() {
    return {
      menu: menu[4].submenu
    };
  },
  computed: {
    uri() {
      return this.$i18n.locale + "/" + this.$route.params.title + ".md"
    },
    document() {
      var Component;
      try {
        var html = require("@/docs/" + this.uri);
        html = html.replace(/\$\$([\s\S]+?)\$\$/g, (match, p1) => {
          return (
            "<div class='katex-formula-container md-elevation-1'><div class='katex-formula' v-katex=\"'" +
            p1
              .replace(/\\/g, "\\\\")
              .replace(/\n/g, " ")
              .replace(/&amp;/, "&") +
            "'\"></div></div>"
          );
        });
        html = html.replace(/<h1(.*)>/g, '<h1 class="md-display-1"$1>');
        html = html.replace(/<(\/?)table>/g, "<$1md-table>");
        html = html.replace(/<(\/?)tr>/g, "<$1md-table-row>");
        html = html.replace(/<(\/?)th>/g, "<$1md-table-head>");
        html = html.replace(/<(\/?)td>/g, "<$1md-table-cell>");
        html = html.replace(/<(\/?)thead>/g, "");
        html = html.replace(/<(\/?)tbody>/g, "");
        Component = Vue.extend({
          template: `<div>${html}</div>`,
          components: { WIP }
        });
      } catch (e) {
        Component = Vue.extend({
          template: `<div></div>`
        });
      }

      return Component;
    }
  }
};
</script>

<style lang="scss">
.document-container {
  margin: 8px;
}

.document {
  max-width: 768px;
  margin: auto;
}

.katex-formula-container {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  padding: 16px;
}

.katex-formula {
  text-align: center;
  font-size: 12px;
}

.document-edit {
  padding: 16px;
}
</style>